import { Button } from '@/components/ui/button';
import { ChevronDown } from 'lucide-react';

const HeroSection = () => {
  const scrollToNext = () => {
    const element = document.getElementById('biographie');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="accueil" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background avec gradient */}
      <div className="absolute inset-0 gradient-hero"></div>
      
      {/* Overlay pour améliorer la lisibilité */}
      <div className="absolute inset-0 bg-black/20"></div>

      {/* Contenu principal */}
      <div className="relative z-10 container mx-auto px-4 text-center text-white">
        <div className="max-w-4xl mx-auto">
          {/* Portrait du Président */}
          <div className="mb-8">
            <img 
              src="/images/president_portrait_1.jpeg" 
              alt="Président Bassirou Diomaye Faye" 
              className="w-64 h-80 mx-auto object-cover rounded-lg shadow-elegant border-4 border-white/20"
            />
          </div>

          {/* Titre principal */}
          <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
            Son Excellence
            <br />
            <span className="text-secondary">Bassirou Diomaye Faye</span>
          </h1>

          {/* Sous-titre */}
          <p className="text-xl md:text-2xl mb-8 text-white/90 font-light">
            Cinquième Président de la République du Sénégal
          </p>

          {/* Description */}
          <p className="text-lg md:text-xl mb-12 text-white/80 max-w-3xl mx-auto leading-relaxed">
            Né le 25 mars 1980 à Ndiaganiao, Bassirou Diomaye Faye incarne une nouvelle génération de leadership 
            au Sénégal. Inspecteur des finances publiques devenu Président, il porte une vision de transformation 
            et de souveraineté pour le Sénégal.
          </p>

          {/* Boutons d'action */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16">
            <Button 
              size="lg" 
              className="bg-white text-primary hover:bg-white/90 font-semibold px-8 py-3"
              onClick={() => document.getElementById('biographie')?.scrollIntoView({ behavior: 'smooth' })}
            >
              Découvrir sa biographie
            </Button>
            <Button 
              size="lg" 
              variant="outline" 
              className="border-white text-white hover:bg-white hover:text-primary font-semibold px-8 py-3"
              onClick={() => document.getElementById('vision')?.scrollIntoView({ behavior: 'smooth' })}
            >
              Sa vision pour le Sénégal
            </Button>
          </div>

          {/* Indicateur de scroll */}
          <button 
            onClick={scrollToNext}
            className="animate-bounce text-white/70 hover:text-white transition-colors"
          >
            <ChevronDown className="w-8 h-8 mx-auto" />
          </button>
        </div>
      </div>

      {/* Éléments décoratifs */}
      <div className="absolute top-20 left-10 w-20 h-20 bg-secondary/20 rounded-full blur-xl"></div>
      <div className="absolute bottom-20 right-10 w-32 h-32 bg-accent/20 rounded-full blur-xl"></div>
    </section>
  );
};

export default HeroSection;